<template>
  <div>
    <PageTitle v-bind:title="title" v-bind:admin="false" />

    <!-- <SlidersTest /> -->

    <div class="bg-red-50" v-if="errors.load">
      {{ errors.load }}
    </div>

    <Loader v-if="loading" />
    <div
      v-else-if="data.user.id"
      class="max-w-sm mx-auto my-8 text-center sm:text-left space-y-4 sm:grid sm:grid-cols-3 sm:gap-6 sm:space-y-0 lg:gap-8"
    >
      <div class="h-0 aspect-w-3 aspect-h-2 sm:aspect-w-3 sm:aspect-h-4">
        <img
          class="object-cover shadow-lg rounded-lg"
          :src="data.user.userphoto"
          alt=""
        />
      </div>
      <div class="sm:col-span-2">
        <div class="space-y-4">
          <div class="text-lg leading-6 font-medium space-y-1">
            <h3 class="text-lg font-bold">{{ data.user.fullname }}</h3>
            <p class="text-indigo-600">
              {{ data.user.description }}

              <span
                v-if="data.user.is_author"
                class="px-2 py-1 text-indigo-800 text-xs font-medium bg-green-100 rounded-full"
                >Автор</span
              >
              <span
                v-if="data.user.is_admin"
                class="px-2 py-1 text-green-800 text-xs font-medium bg-green-100 rounded-full"
                >Администратор</span
              >
            </p>
          </div>
          <dl class="mt-1 flex-grow flex flex-col justify-between">
            <dt v-if="data.user.is_author">Кол-во опубликованных курсов</dt>
            <dd v-if="data.user.is_author" class="text-gray-500 text-sm">
              {{ data.user.courses.length }}
            </dd>
            <dt v-if="!data.user.is_simple">Кол-во пройденных курсов</dt>
            <dd v-if="!data.user.is_simple" class="text-gray-500 text-sm">
              {{ data.user.courses_done.length }}
            </dd>

            <dt>Дата регистрации</dt>
            <dd class="text-gray-500 text-sm">
              {{ localeDate }}
            </dd>
            <dt v-if="!data.user.is_simple">Должность</dt>
            <dd v-if="!data.user.is_simple" class="text-gray-500 text-sm">
              {{ data.user.doljnost }}
            </dd>
            <dt>Контакты</dt>
            <dd class="text-gray-500 text-sm">
              {{ data.user.contacts }}
            </dd>

          </dl>
        </div>
      </div>
    </div>
    <div class="bg-white">
      <div class="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24"></div>
    </div>

    <!-- <div class="my-5">
      <div class="row my-5 p-5">
        <div class="col-12 col-md-4">
          <img
            :src="data.user.userphoto"
            class="d-block mx-auto w-75 rounded-lg"
            style="opacity: 0.9"
            alt=""
          />

          <div class="text-center my-4">
            <h4>{{ data.user.fullname }}</h4>
          </div>
          <div class="text-center my-4">
            <p>{{ data.user.description }}</p>
          </div>
        </div>
        <div class="col-12 col-md-8">
          <p v-if="data.user.is_author" class="text-center text-md-left">
            <strong>Кол-во курсов:</strong> {{ data.user.courses.length }}
          </p>

          <p class="text-center text-md-left">
            <strong>Дата регистрации:</strong> {{ localeDate }}
          </p>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import PageTitle from "@/components/PageTitle";
// import SlidersTest from '@/components/SlidersTest'

//import jQuery from 'jquery'
export default {
  data() {
    return {
      loading: true,
      data: [],
      errors: { load: "" },
      title: "Информация о пользователе",
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get("users/" + this.$route.params.id);
        this.data = response.data;
        this.loading = false;
      } catch (e) {
        this.errors.load = "Ошибка при загрузке данных";
      }
    },
  },

  computed: {
    localeDate() {
      // Конвертируем число в строку. Для этого существуют специальные методы
      // toLocaleDateString() или toLocaleString() или toLocaleTimeString()
      // Итоговая строка будет зависеть от локализации системы пользователя.
      // Для русской локали это будет "01.02.2020",
      // для американской "2/1/2020",
      // для немецкой — "1.2.2020"
      // Вы НЕ должны устанавливать формат даты самостоятельно
      return new Date(this.data.user.created_at).toLocaleDateString();
    },
  },

  components: {
    Loader,
    PageTitle,
    // SlidersTest
  },
};
</script>

<style scoped>
.user-profile__badge {
  z-index: 100;
  position: absolute;
  top: 10px;
  right: 10%;
}
</style>